import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@atenea-cms";
import { FlexLayoutModule } from "@angular/flex-layout";

import { AteneaModule } from "@atenea-cms";
import { CommonModule } from "../common";
import { CategoriesRoutes } from "./categories.routes";
import { CategoryListComponent } from "./category-list/category-list.component";
import { CategoryFormComponent } from "./category-form/category-form.component";
import { CategoryService, CategoryFormService } from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    FlexLayoutModule,
    AteneaModule,
    CommonModule,
    CategoriesRoutes,
  ],
  declarations: [CategoryListComponent, CategoryFormComponent],
  providers: [CategoryService, CategoryFormService],
})
export class CategoriesModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/categories/categories.module.ts